import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const listTickets = () => {
    return api.get(ENDPOINTS.SUPPORT.LIST);
};

export const createTicket = (data) => {
    return api.post(ENDPOINTS.SUPPORT.CREATE, data);
};

export const getTicketDetails = (ticketNumber) => {
    return api.get(ENDPOINTS.SUPPORT.DETAIL(ticketNumber));
};

export const addMessage = (ticketNumber, data) => {
    return api.post(ENDPOINTS.SUPPORT.ADD_MESSAGE(ticketNumber), data);
};

export const reopenTicket = (ticketNumber) => {
    return api.put(ENDPOINTS.SUPPORT.REOPEN(ticketNumber));
};
